module.exports = __webpack_public_path__ + "img/sideop-png.76007c5c.png";